module.exports = __webpack_public_path__ + "img/map-A-part-2.45feccc9.svg";